// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1d9SA","label":"Section_label__2KIwh","contentWrap":"Section_contentWrap__2Lc6v","footer":"Section_footer__1xExK","footerInner":"Section_footerInner__28FwF"};